import {MeupRole} from "../model/meup_roles";
import {MeupStatut} from "../model/meup_statuts";

export interface AuthorizationEntry {
    role: MeupRole;
    statut?: MeupStatut;
    excludedStatut?: MeupStatut;
}

class AuthorizationService {
    private currentRoles: MeupRole[] = [];
    private currentStatuts: MeupStatut[] = [];

    /**
     * Parse memberships array and extract roles/statuts
     * Input: ["/role/formateur", "/statut/payant", "/statut/cotisant", "/organisation/CCI"]
     */
    parseMemberships(memberships: string[]): void {
        this.currentRoles = memberships
            .filter(m => m.startsWith('/role/'))
            .map(m => m.substring(6) as MeupRole);

        if (this.currentRoles.length === 0) {
            this.currentRoles = ['visiteur'];
        }

        this.currentStatuts = memberships
            .filter(m => m.startsWith('/statut/'))
            .map(m => m.substring(8) as MeupStatut);
    }

    getRoles(): MeupRole[] {
        return this.currentRoles;
    }

    getStatuts(): MeupStatut[] {
        return this.currentStatuts;
    }

    /**
     * Check if current user matches an authorization entry
     * - Role must match
     * - If statut specified in entry, user must have that statut
     * - If excludedStatut specified in entry, user must not have that statut
     */
    matchesAuthorization(auth: AuthorizationEntry): boolean {
        if (!this.currentRoles.includes(auth.role)) return false;
        if (auth.excludedStatut && this.currentStatuts.includes(auth.excludedStatut)) return false;
        if (auth.statut) return this.currentStatuts.includes(auth.statut);
        return true;
    }

    /**
     * Check if current user matches ANY entry in authorization array
     */
    isAuthorized(authorizations: AuthorizationEntry[]): boolean {
        return authorizations.some(auth => this.matchesAuthorization(auth));
    }
}

export const authorizationService = new AuthorizationService();
